import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

const StyledTextBlock = styled.div`
  margin-top: 32px;

  ${breakpointsMedia({
    xs: css`
      font-size: 16px;
    `,
    md: css`
      font-size: 24px;
    `,
  })}

  strong {
    font-weight: 600;
  }

  p {
    padding: 16px 0;
  }

  ul {
    list-style: inside;
  }

  li {
    padding: 0 0 16px;
  }

  a {
    text-decoration: underline;

    :hover {
      opacity: 0.7;
    }
  }
`;

const ContractTextBlock = ({ data }) => (
  <StyledTextBlock dangerouslySetInnerHTML={{ __html: data }} />
);

ContractTextBlock.propTypes = {
  data: PropTypes.string.isRequired,
};

export default ContractTextBlock;
